import { useEffect, useState } from "react";
import {
  getAemBodyScripts,
  getAemHeader,
  getAemHeadLinks,
  getAemHeadScripts,
} from "~/utils/adobe";
import { fetchAemHeader } from "~/common/api/adobe";

export function HeaderView() {
  const [loaded, setLoaded] = useState(false);
  let linksLoaded: boolean[] = [];

  // djboulia [04/07/2026] HACK HACK HACK
  // I originally tried to disable loading all of these header scripts from the AEM page load
  // They seem related to other AEM page functions (which we don't use in WordPress)
  // And they cause conflicts with Elementor's editor scripts. Specifically, the AEM
  // pages load a very old, AEM specific version of JQuery. Elementor uses
  // a much newer version of JQuery.  Unfortunately, this section is also where all of our analytics
  // are loaded (Google Analytics, Heap, Facebook Pixel, etc). So I look for the
  // first jQuery library loaded and skip it.  This avoids loading a very old JQuery which
  // will conflict with Elementor.

  const addHeadScripts = (scripts: string[]) => {
    let foundOldJQueryLib = false;
    scripts.forEach((src) => {
      if (src.includes("jquery") && !foundOldJQueryLib) {
        // console.log(
        //   `Skipping head script with src ${src} to avoid conflicts with Elementor's editor`,
        // );
        foundOldJQueryLib = true;
        return;
      }
      const script = document.createElement("script");
      script.src = src;
      script.async = false; // to preserve execution order
      document.head.appendChild(script);
    });
  };

  const addBodyScripts = (scripts: string[]) => {
    scripts.forEach((src) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = false; // to preserve execution order
      document.body.appendChild(script);
    });
  };

  const addLinks = (links: string[]) => {
    linksLoaded = new Array(links.length).fill(false);

    links.forEach((href, index) => {
      const link = document.createElement("link");
      link.href = href;
      link.rel = "stylesheet";
      link.type = "text/css";
      link.onload = () => {
        // console.log(`Loaded CSS: ${href}`);
        linksLoaded[index] = true;
      };
      link.onerror = () => {
        console.error(`Error loading CSS: ${href}`);
        linksLoaded[index] = true; // consider errored links as "loaded" to avoid blocking
      };
      document.head.appendChild(link);
    });
  };

  const addHeader = (html: string) => {
    const div = document.createElement("div");
    div.style.display = "none";
    div.innerHTML = html;
    document.body.insertBefore(div, document.body.firstChild);

    // wait for all stylesheets to load before displaying header to avoid FOUC
    // definition of FOUC: https://en.wikipedia.org/wiki/Flash_of_unstyled_content
    const interval = setInterval(() => {
      if (linksLoaded.every((loaded) => loaded)) {
        clearInterval(interval);
        console.log("All links loaded, displaying header");
        div.style.display = "block";
        setLoaded(true);
      }
    }, 50);
  };

  useEffect(() => {
    const fetchHeader = async () => {
      const content = await fetchAemHeader();
      const body = content?.body;
      const aemUrl = content?.aemUrl;
      // console.log(`Fetched AEM Header HTML ${aemUrl}:`, body);

      const links = await getAemHeadLinks(aemUrl, body);
      addLinks(links);

      const scriptsHead = await getAemHeadScripts(aemUrl, body);
      addHeadScripts(scriptsHead);

      const scriptsBody = await getAemBodyScripts(aemUrl, body);
      addBodyScripts(scriptsBody);

      const headerHtml = await getAemHeader(aemUrl, body);
      addHeader(headerHtml ?? "");
    };

    fetchHeader();
  }, []);

  // put a spacer in place until the header is loaded to avoid layout shift
  if (!loaded) {
    return <div className="tw:h-[134px]">&nbsp;</div>;
  }

  // we inject all of the header HTML directly into the body, so nothing to render here
  return null;
}
